/**
 * @fileOverview This file contains the implementation of the hook to manage the tour/tutorial in Equipments module.
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

import { Typography } from "@mui/material";
import { useTranslationHook } from "../hooks/UseTranslationHook";

const useEquipsTour = (setModalEShow) => {
  const {
    equipsS1P1,
    equipsS1P2,
    equipsS2P1,
    equipsS2P2,
    equipsS3P1,
    equipsS3P2,
    equipsS3P3,
    equipsS3P4,
    equipsS3P5,
    equipsS4P1,
    equipsS4P2,
    equipsS5P1,
    equipsS5P2,
  } = useTranslationHook();

  return [
    {
      selector: ".create-equip-tour",
      content: (
        <Typography>
          <strong>{equipsS1P1}</strong> {equipsS1P2}
        </Typography>
      ),
      action: () => setModalEShow(false),
      stepInteraction: false,
    },
    {
      content: (
        <Typography>
          {equipsS2P1} <strong>{equipsS2P2}</strong>.
        </Typography>
      ),
      action: () => setModalEShow(true),
      stepInteraction: false,
    },
    {
      selector: ".create-equip-form-tour",
      content: (
        <Typography>
          {equipsS3P1} <strong>{equipsS3P2}</strong>. {equipsS3P3}{" "}
          <strong>{equipsS3P4}</strong> {equipsS3P5}
        </Typography>
      ),
      action: () => setModalEShow(true),
      stepInteraction: false,
    },
    {
      selector: ".equips-datagrid-tour",
      content: (
        <Typography>
          {equipsS4P1} <strong>{equipsS4P2}</strong>.
        </Typography>
      ),
      action: () => setModalEShow(false),
      stepInteraction: false,
    },
    {
      selector: ".equips-datagrid-actions-tour",
      content: (
        <Typography>
          {equipsS5P1} <strong>{equipsS5P2}</strong>.
        </Typography>
      ),
      action: () => setModalEShow(false),
      stepInteraction: false,
    },
  ];
};

export default useEquipsTour;
